export enum IDProps {
    REASON_ID = 'reasonId',
    STAFF_ID = 'professionalId'
}
